module.exports = __webpack_public_path__ + "static/media/locked-services-icon.0c1014d5.svg";